// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ExtEnrollmentHybridEnrollmentResultModelResponse {
    static getAttributeTypeMap() {
        return ExtEnrollmentHybridEnrollmentResultModelResponse.attributeTypeMap;
    }
}
ExtEnrollmentHybridEnrollmentResultModelResponse.discriminator = undefined;
ExtEnrollmentHybridEnrollmentResultModelResponse.additionalProperties = false;
ExtEnrollmentHybridEnrollmentResultModelResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "ExtEnrollmentHybridEnrollmentResultModel"
    },
];
//# sourceMappingURL=extEnrollmentHybridEnrollmentResultModelResponse.js.map